module.exports = __webpack_public_path__ + "img/c02_unitaxeman_Normal_ua.b7cf2a3a.webp";